import React, { FC, ReactNode } from 'react';

import s from './EditableTripDetails.module.scss';

type EditableTripDetailsProps = {
  children: ReactNode;
};

const EditableTripDetails: FC<EditableTripDetailsProps> = ({
  children,
}) => (
  <div className={s.root}>
    {children}
  </div>
);

export default EditableTripDetails;
